<template>
    <div class="w-100 overflow">
        <Navigation pageName="customclient" />
        <div v-if="iframeLoading" class="d-flex flex-justify-center  p-5">
            <span class="mif-spinner2 fg-primary ani-spin mif-3x " />
        </div>

        <!--NoDataAvailable v-else-if="groups.length == 0" :message="$t('No groups available')" /-->

        <div class="row p-4">
            <div class="col col-12">

                <iframe ref="customversionIframe" allowfullscreen sandbox="allow-popups allow-top-navigation allow-same-origin allow-scripts allow-modals allow-forms allow-downloads" :src="parentIframeSrc" width="100%" loading="lazy" v-show="!iframeLoading" style="height: calc(100vh - 190px);overflow:auto;border: none; display: block;"></iframe>

            </div>
        </div>

    </div>

</template>
<script>

import Navigation from './utils/Navigation.vue';
import NoDataAvailable from "./utils/NoDataAvailable.vue";
export default {
    name: "CustomClient",
    components: {
        Navigation,
        NoDataAvailable
    },
    data() {
        return {
            urlircustombuild: process.env.VUE_APP_IR_BUILD_BASE_URL,
            parentIframeSrc: '',
            iframeLoading: true
        }
    },
    mounted: function () {
        this.$session.setRoomPC(null);
        this.$root.socket("SETPC", null);

    },
    created: function () {

        this.$root.generateTrustedSsoUrl(this.urlircustombuild, 'custom', '').then(urlcustom => {
            this.parentIframeSrc = urlcustom;
        }),

            setTimeout(() => {
                this.iframeLoading = false; // fallback visuale
            }, 1000); // Cambia lo stato quando il contenuto è caricato

    },
    methods: {

    }
}
</script>
